__turbopack_context__.v({
  "iconWrapper": "_48xPhG_iconWrapper",
  "line": "_48xPhG_line",
  "material-icons": "_48xPhG_material-icons",
  "timeline_block": "_48xPhG_timeline_block",
  "timeline_block__inner": "_48xPhG_timeline_block__inner",
  "timeline_label": "_48xPhG_timeline_label",
  "timeline_text": "_48xPhG_timeline_text",
  "timeline_title": "_48xPhG_timeline_title",
  "timelineiconbox": "_48xPhG_timelineiconbox",
  "timelineinfobox": "_48xPhG_timelineinfobox",
  "timelinerow": "_48xPhG_timelinerow",
});
